// FROM ENV VARS
const APP_ENV = process.env.REACT_APP_ENV_MODE;
// Azure Functions APIs
// used in development only
const AZF_LOCAL_BASE_URL = process.env.REACT_APP_AZF_LOCAL_BASE_URL;
// used in staging only
const AZF_SERVICE_ENDPOINT = process.env.REACT_APP_AZF_SERVICE_ENDPOINT;
const AZF_SERVICE_KEY = process.env.REACT_APP_AZF_SERVICE_KEY;
// Azure API Management URL & Subscription Key & version
// used in production only
const APIM_URL = process.env.REACT_APP_APIM_URL;
const APIM_SUBSCRIPTIONKEY = process.env.REACT_APP_APIM_SUBSCRIPTIONKEY;
const APIM_APIM_VERSION = process.env.REACT_APP_APIM_VERSION;
//console.debug('utils.js - env vars', {APP_ENV, AZF_LOCAL_BASE_URL, AZF_SERVICE_ENDPOINT, AZF_SERVICE_KEY, APIM_URL, APIM_SUBSCRIPTIONKEY, APIM_APIM_VERSION});



// generate ihr auth headers
export const generateiHrAuthHeaders = async (getState, from,) => {
  const state = getState();
  let headers = {
    'X-IHR-PID': state.authIhrWebSdk.authentication.loginData.profileId,
    'X-IHR-SID': state.authIhrWebSdk.authentication.loginData.sessionId,
  }
  //azure functions
  if (AZF_SERVICE_KEY) {
    headers['x-functions-key'] = AZF_SERVICE_KEY;
  }
  // azure APIM
  if (APIM_SUBSCRIPTIONKEY) {
    headers['Ocp-Apim-Subscription-Key'] = APIM_SUBSCRIPTIONKEY;
  }
  if (APIM_APIM_VERSION) {
    headers['API-VERSION'] = APIM_APIM_VERSION;
  }
  return headers
}

// generate API URL
export const generateApiUrl = (from,) => {
  //console.debug('generateApiUrl - from', from);
  const apiUrl = APP_ENV === 'development' ? AZF_LOCAL_BASE_URL : APP_ENV === 'staging' ? AZF_SERVICE_ENDPOINT : APIM_URL;
  return apiUrl
}